import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PolicySeparationLine, PolicyTitle, PolicyWrapper } from '../../../common/policyStyles';
import moment from 'moment';
import ImageIcon from '../../../ImageIcon/ImageIcon';
import { FullColoredButton } from '../../../common/buttonsComponents';
import { PolicyDescriptionError } from './ShopifyPolicy.styles';

const NOT_CONFIGURED = 'This partner has not configured a cancellation or refund policy yet.';

class ShopifyPolicy extends Component {
  static propTypes = {
    isSpecialist: PropTypes.bool.isRequired,
    createdDate: PropTypes.string.isRequired,
    showCancel: PropTypes.bool.isRequired,
    showRefund: PropTypes.bool.isRequired,
    config: PropTypes.object.isRequired,
  };

  state = {
    isPolicyAccepted: false,
  };

  get isSpecialist() {
    return this.props.isSpecialist;
  }

  get refundConfig() {
    return this.props.config['refundConfig'] || {};
  }

  get cancelConfig() {
    return this.props.config['cancelConfig'] || {};
  }

  get refundPolicy() {
    return this.refundConfig['refundPolicy'] || {};
  }

  get refundLimitPrice() {
    const refundPolicyPrice = this.refundPolicy['maxPriceAllowed'];

    return refundPolicyPrice ? parseInt(refundPolicyPrice) : 0;
  }

  get refundLimitDays() {
    const refundPolicyDays = this.refundPolicy['days'];

    return refundPolicyDays ? refundPolicyDays : 0;
  }

  isRefundDateLimitExceeded() {
    const createdDateMoment = moment(this.props.createdDate).format('MM/DD/YYYY');
    const actualDate = moment(new Date()).format('MM/DD/YYYY');

    return !(moment(actualDate).diff(moment(createdDateMoment), 'days') <= this.refundLimitDays);
  }

  get cancelPolicyText() {
    const cancelPolicy = this.cancelConfig.cancelPolicy || {};
    if (cancelPolicy.text && cancelPolicy.text.length) {
      return cancelPolicy.text.join('\n');
    }

    return NOT_CONFIGURED;
  }

  get refundPolicyText() {
    const refundPolicy = this.refundConfig.refundPolicy || {};
    if (refundPolicy.text && refundPolicy.text.length) {
      return refundPolicy.text.join('\n');
    }

    return NOT_CONFIGURED;
  }

  get buttonActive() {
    return (
      (!this.props.showRefund && this.props.showCancel) ||
      (this.props.showRefund && (this.refundLimitDays === 0 || !this.isRefundDateLimitExceeded()))
    );
  }

  get policyTitle() {
    if (!this.props.showRefund) {
      return 'What is the Cancel policy';
    }

    return 'What is the Refund policy?';
  }

  renderPolicy() {
    return (
      <PolicyWrapper>
        <PolicyTitle>{this.policyTitle}</PolicyTitle>
        <ImageIcon src={ImageIcon.type.magnifiedDocument} className="top-image" />

        {this.props.showCancel && <p>{this.cancelPolicyText}</p>}

        {this.props.showRefund && (
          <React.Fragment>
            <p>{this.refundPolicyText}</p>
            {this.refundLimitDays !== 0 && (
              <PolicyDescriptionError isError={this.isRefundDateLimitExceeded()}>
                Orders are available to refund after creation for {this.refundLimitDays} days from order date:{' '}
                {moment(this.props.createdDate).format('MM/DD/YYYY')}.
              </PolicyDescriptionError>
            )}
            {this.refundLimitPrice !== 0 && <p>Available for one refund ${this.refundLimitPrice}.</p>}
          </React.Fragment>
        )}

        <PolicySeparationLine />
        {this.buttonActive && (
          <FullColoredButton type="button" onClick={() => this.setState({ isPolicyAccepted: true })}>
            GO
          </FullColoredButton>
        )}
      </PolicyWrapper>
    );
  }

  render() {
    if (!this.isSpecialist && !this.state.isPolicyAccepted) {
      return this.renderPolicy();
    }

    return this.props.children;
  }
}
export default ShopifyPolicy;
